export const uz = {
  client_privacy: {
    title: "Maxfiylik siyosati",
    effective_date: "Kuchga kirish sanasi: 10.03.2025",
    last_update: "Oxirgi yangilanish sanasi: 10.03.2025",
    introduction: "Ushbu Maxfiylik siyosati \"Nasiyah Client\" mobil ilovasida shaxsiy ma'lumotlarning qanday to'planishi, foydalanilishi va himoya qilinishini tartibga soladi.",
    data_collection: {
      title: "1. Qanday ma'lumotlarni to'playmiz?",
      items: [
        "Telefon raqami (Ilovaga kirish uchun).",
        "Sotuvchi kiritgan ma'lumotlar (ism, tug'ilgan sana, manzil, ID).",
        "Texnik ma'lumotlar (IP-manzil, qurilma haqida ma'lumot, Yandex Metrica statistikasi)."
      ]
    },
    data_usage: {
      title: "2. Ma'lumotlarni nima uchun to'playmiz?",
      items: [
        "Ilovaga kirish va foydalanuvchini aniqlash.",
        "Onlayn shartnomalarni ko'rish va boshqarish.",
        "To'lov jadvalini kuzatish va eslatmalar yuborish.",
        "Ilova ishlashini yaxshilash uchun tahlil qilish."
      ]
    },
    data_protection: {
      title: "3. Ma'lumotlaringizni qanday himoya qilamiz?",
      items: [
        "Barcha ma'lumotlar shifrlangan holda saqlanadi.",
        "Foydalanuvchilar faqat o'z ma'lumotlarini ko'rishlari mumkin.",
        "Serverlar zamonaviy xavfsizlik choralari bilan himoyalangan."
      ]
    },
    data_sharing: {
      title: "4. Ma'lumotlarni uchinchi tomonlarga beramizmi?",
      text: "Biz ma'lumotlarni uchinchi tomonlarga bermaymiz, faqat tahliliy maqsadlarda (Yandex Metrica) yoki qonun talabiga binoan."
    },
    payment_data: {
      title: "5. To'lov ma'lumotlari",
      text: "Ilova to'lov ma'lumotlarini saqlamaydi va qayta ishlamaydi. Barcha to'lovlar sotuvchi bilan bevosita amalga oshiriladi."
    },
    user_rights: {
      title: "6. Huquqlaringiz",
      text: "Foydalanuvchilar o'z shaxsiy ma'lumotlarini ko'rish, tahrirlash yoki o'chirish huquqiga ega."
    },
    analytics: {
      title: "7. Tahliliy vositalardan foydalanish",
      text: "Ilova ishlashini tahlil qilish uchun Yandex Metrica xizmatidan foydalanadi."
    },
    age_restriction: {
      title: "8. Ilovadan kimlar foydalanishi mumkin?",
      text: "Ilova faqat 18 yoshdan katta foydalanuvchilar uchun mo'ljallangan."
    },
    policy_changes: {
      title: "9. Siyosatdagi o'zgarishlar",
      text: "Yangilangan siyosat Ilovada e'lon qilinadi."
    },
    contact: {
      title: "10. Aloqa ma'lumotlari",
      email: "Email: support@nasiyah.uz",
      phone: "Telefon: +998933852600",
      address: "Manzil: Toshkent shahri, Olmazor tumani, Sag'bon ko'chasi, 23A-uy"
    }
  },
  client_terms: {
    title: "Foydalanish shartlari",
    effective_date: "Kuchga kirish sanasi: 10.03.2025",
    last_update: "Oxirgi yangilanish sanasi: 10.03.2025",
    introduction: "Ushbu Foydalanish shartlari \"Nasiyah Client\" mobil ilovasidan foydalanishni tartibga soladi.",
    description: {
      title: "1. Ilova tavsifi",
      intro: "\"Nasiyah Client\" ilovasi mijozlarga quyidagilarni taqdim etadi:",
      items: [
        "Sotuvchilar tomonidan yuborilgan shartnomalarni ko'rish, qabul qilish yoki rad etish.",
        "To'lov jadvalini kuzatish va eslatmalar olish.",
        "Shartnoma bo'yicha to'lovlarni boshqarish."
      ]
    },
    how_works: {
      title: "2. Ilova qanday ishlaydi?",
      text: "Mijozlar telefon raqami va OTP orqali tizimga kiradi, sotuvchi yuborgan shartnomani tekshiradi va imzolaydi."
    },
    features: {
      title: "3. Mijozlar uchun funksiyalar",
      items: [
        "To'lovni qismlarga bo'lish.",
        "To'lovni keyingi oyga kechiktirish.",
        "Shartnomani muddatidan oldin tugatish.",
        "To'lov muddatlari haqida bildirishnomalar olish."
      ]
    },
    obligations: {
      title: "4. Sizning majburiyatlaringiz",
      text: "Siz shartnomada belgilangan tartibda to'lovlarni amalga oshirishingiz va telefon raqamingizni faol saqlashingiz kerak."
    },
    liability: {
      title: "5. Javobgarlikni cheklash",
      text: "Ilova sotuvchi va mijoz o'rtasidagi nizolar uchun javobgar emas, u faqat to'lovlarni qayd etadi va eslatish uchun xizmat qiladi."
    },
    no_financial: {
      title: "6. Moliyaviy operatsiyalarning mavjud emasligi",
      text: "Ilova to'lovlarni qayta ishlamaydi, barcha pul hisob-kitoblari ilovadan tashqarida amalga oshiriladi."
    },
    termination: {
      title: "7. Foydalanishni to'xtatish",
      text: "Hisobingizni istalgan vaqtda o'chirishingiz mumkin. Agar shartlar buzilsa, ilovaga kirish bloklanishi mumkin."
    },
    law: {
      title: "8. Qo'llaniladigan huquq",
      text: "Shartlar O'zbekiston Respublikasi qonunchiligi bilan tartibga solinadi."
    },
    contact: {
      title: "9. Aloqa",
      email: "Email: support@nasiyah.uz",
      phone: "Telefon: +998933852600",
      address: "Manzil: Toshkent shahri, Olmazor tumani, Sag'bon ko'chasi, 23A-uy"
    }
  },
  offer: {
    title: "Ommaviy oferta",
    status_label: "Aktiv",
    doc_badge: "Rasmiy hujjat · Ommaviy oferta",
    subtitle: "NASIYAH dasturidan foydalanish yuzasidan ommaviy oferta",
    lead: "Mazkur oferta O'zbekiston Respublikasi Fuqarolik kodeksining 832-moddasiga muvofiq tuzilgan bo'lib, \"NASIYAH\" dasturini aksept qilgan har qanday layoqatli jismoniy shaxs uchun amal qiladi.",
    meta: {
      date_label: "Sana va joyi",
      date: "25.02.2026 · Toshkent sh.",
      executor_label: "Ijrochi",
      executor: "\"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" YaTT",
      reg: "Ro'yxat raqami: 3629602 · Shayxontohur tumani Davlat xizmatlari markazi"
    },
    preamble: [
      "Mazkur shartnoma \"NASIYAH\" dasturiy ta'minot vositasiga (keyingi o'rinlarda – dastur) egalik qiluvchi \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" Yakka tartibdagi tadbirkor, Shayxontohur tumani Davlat xizmatlari markazi tomonidan 3629602 ro'yxat raqami bilan tashkil etilgan (keyingi o'rinlarda – Ijrochi), dasturda oldi-sotdi shartnomasi asosida kelishuv qilayotgan taraflar o'rtasida vositachilik xizmatlari yuzasidan O'zbekiston Respublikasi Fuqarolik kodeksining 832-moddasiga muvofiq xizmat ko'rsatish shartnomasini (keyingi o'rinlarda – Shartnoma) tuzish yuzasidan layoqatli bo'lgan jismoniy shaxslarga (keyingi o'rinlarda – Buyurtmachi) rasmiy taklif hisoblanadi.",
      "Buyurtmachi tomonidan mazkur ofertada belgilangan harakatlarning bajarilishi, u tomonidan quyidagi shartlar so'zsiz qabul qilinganligini anglatadi (Ofertaning aksepti). Ofertani aksept qilgan paytdan shartnoma tuzilgan hisoblanadi.",
      "Mazkur shartnomada to'g'ridan-to'g'ri nazarda tutilmagan barcha hollarda tomonlar O'zbekiston Respublikasi qonun hujjatlari va ish muomalasi odatlariga rioya qiladilar."
    ],
    sections: [
      {
        title: "01. Atama va ta'riflar",
        body: [
          "1.1. Mazkur shartnomada quyidagi atama va ta'riflar qo'llaniladi:",
          "Bank kartasi – onlayn rejimda ishlovchi, O'zbekiston Respublikasi banki tomonidan chiqarilgan va yetkazib beruvchining to'lov servisida ro'yxatdan o'tkazilgan to'lov karta.",
          "Shaxsga doir ma'lumotlar – servisdan foydalanish uchun foydalanuvchi tomonidan taqdim etilgan muayyan jismoniy shaxsga taalluqli bo'lgan yoki uni identifikatsiya qilish imkonini beradigan axborot.",
          "Oldi-sotdi shartnomasi – Oldi-sotdi shartnomasi bo'yicha bir taraf (sotuvchi) tovarni boshqa taraf (sotib oluvchi)ga mulk qilib topshirish majburiyatini, sotib oluvchi esa bu tovarni qabul qilish va uning uchun belgilangan pul summasi (bahosi)ni to'lash majburiyatini oladi.",
          "Buyurtmachi – O'zbekiston Respublikasi Fuqarolik kodeksining 832-moddasiga muvofiq xizmat ko'rsatish shartnomasini (keyingi o'rinlarda – Shartnoma) tuzish yuzasidan layoqatli bo'lgan jismoniy shaxs.",
          "Ijrochi – Shayxontohur tumani Davlat xizmatlari markazi tomonidan 3629602 ro'yxat raqami bilan tashkil etilgan \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" YaTT."
        ]
      },
      {
        title: "02. Aksept tartibi",
        body: [
          "2.1. Mazkur Ofertaning aksepti Buyurtmachi tomonidan shartnoma bilan tanishib chiqib, maxsus dasturda tanishib chiqqanligi to'g'risida belgi qo'yilgach amalga oshiriladi.",
          "2.2. Mazkur Shartnomani tuzish orqali buyurtmachi ijrochiga amaldagi shaxsga doir ma'lumotlar to'g'risidagi qonun hujjatlari talablariga muvofiq o'zining shaxsga doir ma'lumotlaridan (Familiya, ism, sharifi, JSHSHIR, Passport seriyasi va raqami, tug'ilgan yili va joyi, yashash manzili va telefon raqami) foydalanishga muddatsiz roziligini beradi, shu jumladan, ularni yig'ish, tizimlashtirish, saqlash, aniqlashtirish (yangilash, o'zgartirish), ko'chirish, foydalanish, ularni taqiqlash, ularni o'chirish va ularni yo'q qilish, avtomatizatsiya vositalaridan foydalangan yoki ulardan foydalanmagan holda, ushbu shartnomani bajarish maqsadida. Shuningdek, ushbu orqali buyurtmachi mazkur shartnoma bo'yicha ijrochiga taqdim etilgan shaxsga doir ma'lumotlarni ushbu shartnomani bajarish maqsadida uchinchi shaxslarga taqdim etishga rozilik beradi.",
          "2.3. Ijrochi Buyurtmachining shaxsga doir ma'lumotlarning maxfiyligi bo'yicha O'zbekiston Respublikasi amaldagi qonun hujjatlari, \"Shaxsga doir ma'lumotlar to'g'risida\"gi Qonuni talablariga muvofiq barcha zarur bo'lgan choralarni ko'rishini Buyurtmachiga kafolatlaydi. Ijrochi uning shaxsga doir ma'lumotlariga ishlov berishga roziligi (shu jumladan uchinchi shaxslarga ham) muddatsiz hisoblanadi.",
          "2.4. Xizmatdan foydalanishdan avval Buyurtmachi mazkur Ofertaning matni bilan to'liq tanishib chiqishi zarur. Ofertaning shartlari bilan to'liq yoki qisman norozi bo'lsangiz, xizmatdan foydalanishdan bosh tortishingiz zarur."
        ]
      },
      {
        title: "03. Shartnoma predmeti",
        body: [
          "3.1. \"Ijrochi\" \"Buyurtmachi\"ning topshirig'i bilan uning shaxsga doir ma'lumotlarini maxsus dasturda ro'yxatdan o'tkazishi, \"Buyurtmachi\" esa maxsus dasturdan ro'yxatdan o'tgan holda sotmoqchi yoki sotib olmoqchi bo'lgan tovari, uning xususiyatlari, xarakteri, ishlab chiqarilgan yili, holati va u to'g'risida barcha kerakli ma'lumotlarni, tasvirlarni joylashtirish, ikkinchi taraf bilan esa oldi-sotdi shartnomasini kelishuvga asosan tuzish majburiyatini oladi.",
          "3.2. Ushbu shartnomaga ko'ra \"Ijrochi\" tomonidan \"NASIYAH\" dasturi orqali ko'rsatiladigan xizmatlar: sotuvchi va sotib oluvchini axborot texnologiyalari vositasida bog'lash; bo'lib to'lash shartlari bo'yicha ma'lumot almashish imkonini yaratish; shartnoma tuzish jarayonini avtomatlashtirish; to'lov jadvalini aks ettirish; texnik va axborot xizmatlarini ko'rsatadi, axborot xavfsizligini ta'minlaydi. IJROCHI tovar (ish, xizmat) sotish, yetkazib berish yoki to'lovlarni qabul qilishda ishtirok etmaydi."
        ]
      },
      {
        title: "04. Shartnoma narxi va hisob-kitoblar tartibi",
        body: [
          "4.1. Oferta narxi \"NASIYAH\" dasturida \"PRO\" xizmatlaridan foydalanishda belgilangan narxdagi to'lovlar asosida olib boriladi.",
          "4.2. Oferta uchun to'lovlar 100 foiz oldindan amalga oshiriladi va qilingan to'lov faqatgina 1 kalendar oy uchun amal qiladi. To'lovning amal qilish doirasi to'lov qilingan kundan boshlab keyingi oyning xuddi shu kuniga qadar amal qiladi.",
          "4.3. To'lov \"NASIYAH\" dasturi huquqiy egasi hisoblangan IJROCHIning hisob-raqamiga o'tkazish orqali amalga oshiriladi."
        ]
      },
      {
        title: "05. Taraflarning huquq va majburiyatlari",
        body: [
          "5.1. \"Ijrochi\"ning huquq va majburiyatlari:",
          "5.1.1. Sotuvchi va sotib oluvchi nizolari: Sotuvchi va Sotib oluvchi o'rtasida tuziladigan bitimlar bo'yicha: tovar sifati; yetkazib berish; to'lovlarning o'z vaqtida amalga oshirilishi; kechikishlar; jarimalar; qarzdorlik; shartnomani bekor qilish; da'volar va nizolar uchun IJROCHI javobgar hisoblanmaydi. Bunday nizolar faqat Sotuvchi va Sotib oluvchi o'rtasida mustaqil ravishda hal etiladi.",
          "5.1.2. To'lovlar va kechikishlar bo'yicha: IJROCHI: to'lovlarning o'z vaqtida amalga oshirilishini kafolatlamaydi; qarzdorlikni undirish bilan shug'ullanmaydi; penya, jarima va foizlar hisoblashda ishtirok etmaydi; to'lov majburiyatlari bo'yicha tomonlardan birining vakili hisoblanmaydi. Sotib oluvchi tomonidan to'lovlar kechiktirilgan taqdirda, IJROCHI hech qanday moliyaviy yoki huquqiy javobgarlikni o'z zimmasiga olmaydi.",
          "5.1.3. IJROCHI sotuvchi va sotib oluvchi o'rtasidagi bitimda tomon, vositachi, kafil, agent, vakil hisoblanmaydi.",
          "5.1.4. Ijrochi faqatgina dastur ishlashi, texnik uzilishlarni bartaraf etish, axborot xavfsizligi doirasida javobgar bo'ladi. IJROCHI Buyurtmachilarning moliyaviy yo'qotishlari uchun javobgar emas.",
          "5.2. \"Buyurtmachi\"ning huquq va majburiyatlari:",
          "5.2.1. Oldi-sotdi shartnomasi bo'yicha Sotuvchi quyidagilarga majbur: tovar haqida, uning xarakteristikasi, boshqa barcha kerakli ma'lumotlarni to'liq va ishonchli ma'lumot berish; tovarni Sotib oluvchiga yetkazib berish va uni topshirish; nizo yuzaga kelganda mustaqil javob berish.",
          "5.2.2. Oldi-sotdi shartnomasi bo'yicha Sotib oluvchi quyidagilarga majbur: to'lovlarni belgilangan jadval asosida amalga oshirish; shartnoma shartlariga rioya qilish; to'lovlardagi kechikishlar uchun javobgarlikni o'z zimmasiga olish."
        ]
      },
      {
        title: "06. Taraflarning javobgarligi",
        body: [
          "6.1. Taraflarning javobgarligi O'zbekiston Respublikasi Fuqarolik kodeksi, \"Xo'jalik yurituvchi subyektlar faoliyatining shartnomaviy huquqiy bazasi to'g'risida\"gi Qonuni bilan belgilanadi.",
          "6.2. Taraflarning ushbu shartnomada nazarda tutilmagan javobgarlik choralari O'zbekiston Respublikasining amaldagi qonun hujjatlariga muvofiq qo'llaniladi."
        ]
      },
      {
        title: "07. Nizolarni hal etish tartibi",
        body: [
          "7.1. Ushbu shartnomani bajarish chog'ida va bajarilmasligi oqibatida yuzaga kelishi mumkin bo'lgan nizolar hamda kelishmovchiliklar Taraflar o'rtasidagi muzokaralar yo'li bilan hal etiladi.",
          "7.2. Nizolarni muzokaralar yo'li bilan hal etishning imkoni bo'lmagan taqdirda Taraflar kelishmovchiliklarni sudgacha tartibga solishning amaldagi qonun hujjatlarida nazarda tutilgan tartibotini amalga oshirganlaridan so'ng ularni ko'rib chiqish va hal qilish uchun tegishlilik hamda taalluqliligiga ko'ra Toshkent shahar tumanlararo iqtisodiy sudiga murojaat etiladi."
        ]
      },
      {
        title: "08. Qo'shimcha shartlar va yakunlovchi qoidalar",
        body: [
          "8.1. \"Ijrochi\" tomonidan shartnoma majburiyatlari bajarilmaganda yoki lozim darajada bajarilmaganda \"Buyurtmachi\"ning talabiga asosan shartnoma muddatidan oldin bir tomonlama bekor qilinadi.",
          "8.2. \"Ijrochi\" tomonidan shartnomani muddatidan oldin bekor qilish yozma ravishda murojaat etish yo'li bilan amalga oshiriladi. Bunda shartnoma bo'yicha majburiyatlar lozim darajada bajarilgan yohud majburiyatlar bajarilmagan bo'lsa, uning bajarib bo'lmaslik sabablari ko'rsatilishi shart. Shartnomani muddatidan oldin bekor qilish sabablari Taraflar ishtirokida ko'rib chiqiladi va tegishli tartibda rasmiylashtiriladi.",
          "8.3. Ushbu shartnomaning amal qilish muddati tugagandan keyin taraflar o'rtasidagi majburiyatlarning bajarilishi o'z-o'zidan to'xtatiladi. Bunda taraflarning yozma ravishdagi roziliklar talab etilmaydi.",
          "8.4. Ushbu xizmat ko'rsatish to'g'risidagi shartnoma fuqaroviy-huquqiy tusdagi shartnoma hisoblanib, uning bajarilishi tartibi Mehnat kodeksi va qonunchiligidagi normalarga, shuningdek, munosabatlarga tadbiq etilmaydi."
        ]
      }
    ],
    requisites: {
      title: "Ijrochi rekvizitlari",
      rows: [
        { label: "Tashkilot", value: "\"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" YaTT" },
        { label: "Ro'yxat raqami", value: "3629602" },
        { label: "Ro'yxatga olgan organ", value: "Shayxontohur tumani Davlat xizmatlari markazi" },
        { label: "Platforma", value: "NASIYAH — axborot-texnik vositachi" }
      ]
    },
    acceptance: "✓ Elektron aksept — dasturda belgi qo'yish orqali tasdiqlangan. Aksept amalga oshirilgan paytdan shartnoma tuzilgan hisoblanadi · O'zR FK 832-modda."
  },
  privacy: {
    title: "Maxfiylik siyosati",
    status_label: "Aktiv",
    doc_badge: "Rasmiy hujjat · Maxfiylik siyosati",
    subtitle: "NASIYAH (Nasiyah Business) dasturida shaxsga doir ma'lumotlarni qayta ishlash siyosati",
    lead: "Mazkur Maxfiylik siyosati O'zbekiston Respublikasining \"Shaxsga doir ma'lumotlar to'g'risida\"gi Qonuniga muvofiq ishlab chiqilgan bo'lib, NASIYAH dasturida foydalanuvchilarning shaxsga doir ma'lumotlari qanday to'planishi, qayta ishlanishi va himoya qilinishini belgilaydi.",
    meta: {
      date_label: "Kuchga kirish sanasi",
      date: "10.03.2025 · Toshkent sh.",
      executor_label: "Operator",
      executor: "\"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" YaTT",
      reg: "Ro'yxat raqami: 3629602 · Shayxontohur tumani Davlat xizmatlari markazi"
    },
    preamble: [
      "Mazkur siyosat \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" Yakka tartibdagi tadbirkor (keyingi o'rinlarda – Operator) tomonidan \"Nasiyah Business\" dasturi orqali olinadigan shaxsga doir ma'lumotlarni qayta ishlash tartibini tartibga soladi.",
      "Dasturdan foydalanish orqali Foydalanuvchi mazkur siyosatda belgilangan shartlar asosida o'zining shaxsga doir ma'lumotlari qayta ishlanishiga rozilik bildiradi. Siyosat shartlari bilan to'liq yoki qisman rozi bo'lmasangiz, dasturdan foydalanishdan bosh tortishingiz zarur.",
      "Mazkur siyosatda nazarda tutilmagan masalalarda O'zbekiston Respublikasining amaldagi qonun hujjatlari qo'llaniladi."
    ],
    sections: [
      {
        title: "01. Atama va ta'riflar",
        body: [
          "1.1. Mazkur siyosatda quyidagi atama va ta'riflar qo'llaniladi:",
          "Shaxsga doir ma'lumotlar – muayyan jismoniy shaxsga taalluqli bo'lgan yoki uni identifikatsiya qilish imkonini beradigan, elektron va (yoki) qog'oz shaklida qayd etilgan axborot.",
          "Operator – shaxsga doir ma'lumotlarni qayta ishlashni tashkil etuvchi va (yoki) amalga oshiruvchi \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" YaTT.",
          "Foydalanuvchi – \"Nasiyah Business\" dasturidan foydalanuvchi va o'zining shaxsga doir ma'lumotlarini taqdim etuvchi jismoniy shaxs.",
          "Qayta ishlash – shaxsga doir ma'lumotlarni yig'ish, tizimlashtirish, saqlash, o'zgartirish, foydalanish, uzatish, egasizlantirish, bloklash va yo'q qilish bo'yicha amallar.",
          "Dastur – Operatorga tegishli \"Nasiyah Business\" (NASIYAH) dasturiy ta'minoti."
        ]
      },
      {
        title: "02. Umumiy qoidalar",
        body: [
          "2.1. Mazkur siyosatning maqsadi – Foydalanuvchilarning shaxsga doir ma'lumotlarini qonuniy qayta ishlashni ta'minlash hamda ularning maxfiyligi va himoyasiga doir Operator yondashuvini ochiq bayon etishdir.",
          "2.2. Operator shaxsga doir ma'lumotlarni faqat qonuniy, aniq belgilangan maqsadlarda va shu maqsadlarga zarur bo'lgan hajmda qayta ishlaydi."
        ]
      },
      {
        title: "03. To'planadigan shaxsga doir ma'lumotlar",
        body: [
          "3.1. Operator dastur orqali quyidagi shaxsga doir ma'lumotlarni to'plashi mumkin:",
          "Familiya, ism va sharifi;",
          "Telefon raqami;",
          "Tug'ilgan sana;",
          "Yashash manzili;",
          "Shaxsni tasdiqlovchi hujjat (ID) ma'lumotlari."
        ]
      },
      {
        title: "04. Ma'lumotlarni qayta ishlash maqsadlari",
        body: [
          "4.1. Shaxsga doir ma'lumotlar quyidagi maqsadlarda qayta ishlanadi:",
          "Foydalanuvchi hisobini yaratish va boshqarish;",
          "Onlayn bitimlarni tayyorlash va boshqarish;",
          "Foydalanuvchilarni telefon raqami yoki ID orqali identifikatsiya qilish;",
          "Dasturning ishlashini tahlil qilish va xizmat sifatini takomillashtirish."
        ]
      },
      {
        title: "05. Ma'lumotlarni himoya qilish chora-tadbirlari",
        body: [
          "5.1. Operator shaxsga doir ma'lumotlarni ruxsatsiz kirish, o'zgartirish, oshkor qilish yoki yo'q qilinishidan himoya qilish uchun zarur tashkiliy va texnik choralarni ko'radi, jumladan:",
          "Barcha ma'lumotlar shifrlangan holda saqlanadi;",
          "Foydalanuvchilar faqat o'z ma'lumotlariga kirish huquqiga ega bo'ladilar;",
          "Serverlar zamonaviy axborot xavfsizligi choralari bilan himoyalanadi."
        ]
      },
      {
        title: "06. Ma'lumotlarni uchinchi shaxslarga berish",
        body: [
          "6.1. Operator shaxsga doir ma'lumotlarni uchinchi shaxslarga bermaydi. Istisno holatlar – tahliliy maqsadlarda xizmat ko'rsatuvchilar bilan zarur hajmda almashish hamda O'zbekiston Respublikasi qonun hujjatlari talab qiladigan hollar."
        ]
      },
      {
        title: "07. To'lov ma'lumotlari",
        body: [
          "7.1. Dastur to'lov (bank kartasi) ma'lumotlarini saqlamaydi va qayta ishlamaydi. Barcha to'lovlar tashqi to'lov tizimlari tomonidan, ularning xavfsizlik standartlari asosida amalga oshiriladi."
        ]
      },
      {
        title: "08. Foydalanuvchining huquqlari",
        body: [
          "8.1. Foydalanuvchi o'zining shaxsga doir ma'lumotlarini ko'rish, ularga aniqlik kiritish (tuzatish) yoki o'chirib tashlash, shuningdek qayta ishlashga bergan roziligini qaytarib olish huquqiga ega.",
          "8.2. Bu huquqlardan foydalanish dastur funksionali yoki Operatorning aloqa ma'lumotlari orqali amalga oshiriladi."
        ]
      },
      {
        title: "09. Tahliliy vositalardan foydalanish",
        body: [
          "9.1. Operator dasturdan foydalanishni tahlil qilish va funksionallikni yaxshilash maqsadida Yandex Metrica tahliliy xizmatidan foydalanadi. Bunda ma'lumotlar shaxsni identifikatsiya qilmaydigan, umumlashtirilgan ko'rinishda qayta ishlanishi mumkin."
        ]
      },
      {
        title: "10. Yosh cheklovi",
        body: [
          "10.1. Dastur faqat voyaga yetgan (18 yoshdan katta) shaxslar uchun mo'ljallangan. Operator voyaga yetmaganlarning shaxsga doir ma'lumotlarini bilib turib qayta ishlamaydi."
        ]
      },
      {
        title: "11. Siyosatga o'zgartirishlar",
        body: [
          "11.1. Operator mazkur siyosatga o'zgartirishlar kiritishi mumkin. Yangilangan versiya dasturda e'lon qilingan paytdan boshlab kuchga kiradi."
        ]
      }
    ],
    requisites: {
      title: "Operator rekvizitlari",
      rows: [
        { label: "Tashkilot", value: "\"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" YaTT" },
        { label: "Ro'yxat raqami", value: "3629602" },
        { label: "Ro'yxatga olgan organ", value: "Shayxontohur tumani Davlat xizmatlari markazi" },
        { label: "Platforma", value: "NASIYAH (Nasiyah Business)" },
        { label: "Aloqa", value: "support@nasiyah.uz · +998933852600" }
      ]
    },
    acceptance: "✓ Dasturdan foydalanish orqali Foydalanuvchi mazkur Maxfiylik siyosati shartlarini qabul qilgan hisoblanadi · O'zR \"Shaxsga doir ma'lumotlar to'g'risida\"gi Qonun."
  },
  pricing: {
    eyebrow: "Tariflar",
    title: "Halol tarif — yashirin to‘lovsiz",
    subtitle:
      "Bepul boshlang, biznesingiz o‘sganda PROga o‘ting. Hech qanday yashirin komissiya yo‘q.",
    popular: "Eng ommabop",
    per_month: "so‘m / oy",
    pro: {
      rate: "PRO-tarif",
      payment_text: "Yangi tadbirkorlarga tanishuv",
      intro_headline: "{{months}} oy bepul",
      after_intro: "— keyin shu tarifda",
      btn_text: "{{months}} oy bepul boshlash",
    },
    free: {
      rate: "Bepul",
      price: "0",
      payment_text: "Har doim bepul",
      btn_text: "Bepul boshlash",
    },
    features: {
      debt_book: "Qarz daftaridan foydalanish",
      contracts: "Shartnomalarni tuzish",
      payments: "To‘lovlarni qabul qilish",
      analytics: "Moliyaviy tahlil",
      dashboard: "Boshqaruv paneli va tahlil",
    },
  },
  common: {
    store_small: "Yuklab oling",
    slogan: "Mijoz unutadi, Nasiyah eslatadi!",
  },
  menu: {
    title: "Menyu",
    open: "Menyuni ochish",
    close: "Yopish",
    lang_uz: "O‘zbekcha",
    lang_ru: "Русский",
  },
  dock: {
    ios: "App Store’dan yuklab olish",
    android: "Google Play’dan yuklab olish",
  },
  nav: {
    main: "Asosiy",
    features: "Imkoniyatlar",
    how: "Qanday ishlaydi",
    download: "Yuklab olish",
    pricing: "Narxlar",
    faq: "Savollar",
    cta: "Bepul boshlash",
  },
  hero: {
    eyebrow: "Tadbirkorlar uchun",
    title_pre: "Mijozlaringizga ",
    title_accent: "nasiya savdoni",
    title_post: " oson va ishonchli qiling.",
    subtitle:
      "Qarz daftari, shartnoma va to‘lovlarni bitta ilovada boshqaring — qog‘ozsiz, xatosiz, real vaqtda.",
    trust_count: "1,200+",
    trust_label: "tadbirkor Nasiyah bilan ishlaydi",
    card1_title: "850 000 so‘m qabul qilindi",
    card1_name: "Doniyor Rashidovdan",
    card2_title: "Shartnoma 2506SAR30-1042-TE yopildi",
    card2_name: "Oxirgi to‘lov — bugun",
    mock: {
      title: "Shartnomalar",
      archive: "Arxiv",
      seg_agreements: "Shartnomalar",
      seg_clients: "Mijozlar",
      search: "Mijoz, telefon yoki mahsulot",
      chip_all: "Hammasi",
      chip_overdue: "Muddati o‘tgan",
      chip_active: "Faol",
      chip_pending: "Imzo kutilmoqda",
      status_overdue: "Kechikkan",
      status_pending: "Kutilmoqda",
      status_active: "Faol",
      status_draft: "Qoralama",
      status_closed: "Yopilgan",
      days_late: "{{n}} kun kechikdi",
      next_payment: "Keyingi to‘lov",
      awaiting_sign: "Imzo kutilmoqda",
      resend: "Qayta yuborish",
      months: "{{a}}/{{b}} oy",
      stages: "{{a}}/{{b}} bosqich",
      resume: "Davom ettirish",
      fully_paid: "To‘liq to‘landi",
      create: "Shartnoma tuzish",
      tab_home: "Asosiy",
      tab_agreements: "Shartnomalar",
      tab_inbox: "Kiruvchi",
      tab_debts: "Qarzlar",
      toast_paid: "To‘lov tasdiqlandi",
    },
    stack: {
      accept: "Tasdiqlash",
      reject: "Rad etish",
      remind: "Eslatish",
      stamp_accept: "QABUL",
      stamp_remind: "ESLATILDI",
      payment_in: "To‘lov keldi",
      days_late: "{{n}} kun kechikdi",
      days_until: "{{n}} kundan keyin",
      yesterday: "Kecha",
      toast_reminded: "Eslatma yuborildi",
    },
  },
  featuresCards: {
    card1: {
      title: "Shartnomalarni tez tuzish",
      subtitle: "Raqamli shartnomalarni bir necha klikda tuzing va imzolang.",
    },
    card2: {
      title: "Moslashuvchan to‘lovlar",
      subtitle: "Qisman to‘lash, kechiktirish yoki to‘liq to‘lash.",
    },
    card3: {
      title: "Mijozlarni aqlli boshqarish",
      subtitle:
        "Mijozlar va ularning to‘lovlari haqidagi barcha ma’lumotlar bir joyda.",
    },
    card4: {
      title: "Avtomatik eslatmalar",
      subtitle: "To‘lov muddatlari haqida o‘z vaqtida xabarnomalar.",
    },
    card5: {
      title: "IMEI bloklash",
      subtitle: "To‘lov muddati o‘tganda qurilmani avtomatik bloklash.",
      soon: "Tez orada",
    },
    card6: {
      title: "To‘lov tarixi nazorati",
      subtitle: "Mijozlarning to‘lov tarixini kuzatib boring.",
      soon: "Tez orada",
    },
  },
  main: {
    features: "Imkoniyatlar",
    features_title: "To‘lovlarni xotirjamlik bilan boshqaring",
    features_subtitle:
      "Moslashuvchan shartlarni sozlang, avtomatik eslatmalarni jo‘nating va mijozlarni ortiqcha qiyinchiliksiz boshqaring.",
  },
  how: {
    eyebrow: "Qanday ishlaydi",
    title: "To‘rt qadamda nasiya savdo",
    subtitle:
      "Ro‘yxatdan o‘tishdan birinchi to‘lovgacha — hammasi telefoningizda, ortiqcha qog‘ozsiz.",
    step1_title: "Ilovani yuklab oling",
    step1_text:
      "Nasiyah Biznes ilovasini o‘rnating va do‘koningizni bir daqiqada ro‘yxatdan o‘tkazing.",
    step2_title: "Shartnoma tuzing",
    step2_text:
      "Mahsulot, summa va to‘lov jadvalini tanlang — raqamli shartnoma tayyor.",
    step3_title: "Mijoz imzolaydi",
    step3_text:
      "Mijoz shartnomani telefonida ko‘rib, joyida imzolaydi — qog‘oz kerak emas.",
    step4_title: "Avto eslatma va nazorat",
    step4_text:
      "Tizim to‘lov muddatlarini kuzatadi, mijozga o‘zi eslatadi, siz esa hammasini real vaqtda ko‘rasiz.",
    app: {
      home: {
        greeting: "Xayrli kun,",
        collected: "Sentabrda undirildi",
        trend: "+14% o‘tgan oyga",
        qa_new: "Yangi shartnoma",
        qa_incoming: "Kiruvchi to‘lovlar",
        qa_client: "Mijoz qo‘shish",
        qa_stats: "Statistika",
        pending: "Kutmoqda",
        all: "Hammasi",
        recent: "So‘nggi to‘lovlar",
        confirmed: "Tasdiqlandi",
      },
      create: {
        title: "Yangi shartnoma",
        step_of: "{{n}}/4 · {{name}}",
        step_client: "Mijoz",
        step_type: "Turi",
        step_finance: "Moliya",
        step_docs: "Hujjatlar",
        price: "Umumiy narx",
        down: "Boshlang‘ich to‘lov",
        optional: "ixtiyoriy",
        term: "Muddat",
        months: "{{n}} oy",
        first_date: "Birinchi to‘lov sanasi",
        monthly: "Oylik to‘lov",
        count: "To‘lovlar soni",
        count_value: "{{n}} ta",
        total: "Jami",
        next: "Davom etish",
        photos: "Mahsulot rasmlari",
        photos_hint: "Kamida 1 ta, ko‘pi bilan 4 ta",
        photo: "foto {{n}}",
        add: "Qo‘shish",
        signature: "Mijoz imzosi",
        sign_cta: "Imzo qo‘yish",
        sms_note: "Mijozga SMS orqali imzo havolasi yuboriladi",
        create: "Yaratish",
        sign_hint: "Mijoz shartnomani ko‘rib chiqib, shu yerga imzo qo‘yadi",
        sign_here: "Shu yerga imzo qo‘ying",
        clear: "Tozalash",
        send: "Yuborish",
        signed: "Imzo qo‘yildi",
        redo: "Qayta",
        toast_signed: "Imzo saqlandi",
      },
      detail: {
        title: "Shartnoma",
        type_tech: "Texnika",
        status_overdue: "Muddati o‘tgan",
        remaining: "Qolgan qarz",
        paid: "To‘langan",
        late_text: "{{amount}} to‘lov {{date}}da kutilgan edi",
        schedule: "To‘lov jadvali",
        schedule_meta: "{{n}} oy · {{amount}}",
        row: "{{n}}-to‘lov · {{date}}",
        st_paid: "To‘landi",
        st_late: "Kechikkan",
        st_due: "Kutilmoqda",
        more: "+ yana {{n}} ta to‘lov",
        info: "Ma’lumotlar",
        client: "Mijoz",
        phone: "Telefon",
        start: "Boshlanish",
        number: "Raqam",
        pdf: "Shartnoma PDF",
        accept_pay: "To‘lov qabul qilish",
      },
    },
  },
  stats: {
    eyebrow: "Raqamlarda",
    title: "Tadbirkorlar Nasiyah’ga ishonadi",
    s1_value: "1,247",
    s1_label: "faol tadbirkor",
    s2_value: "38,400+",
    s2_label: "tuzilgan shartnoma",
    s3_value: "4.2 mlrd",
    s3_label: "boshqarilgan to‘lov, so‘m",
    s4_value: "2 daqiqa",
    s4_label: "o‘rtacha shartnoma vaqti",
    unit_bn: "mlrd",
    unit_min: "daqiqa",
    live_hint: "Jonli ma’lumotlar — bevosita platformadan",
  },
  bento: {
    list_title: "Bugungi to‘lovlar",
    list_overdue: "Muddati o‘tgan",
    list_due: "Bugun",
    list_paid: "To‘landi",
    toast_label: "Avto eslatma",
    toast_title: "Eslatma yuborildi",
    toast_text: "Doniyorga — bugun to‘lov muddati",
    pay_label: "To‘lov jadvali",
    pay_status: "Faol",
    sign_label: "Raqamli shartnoma",
    sign_status: "Imzolandi",
    chip_all: "Barchasi",
    chip_debtors: "Qarzdorlar",
    chip_overdue: "Muddati o‘tgan",
    owes: "qarzi",
    paid: "to‘ladi",
    cash_loan: "Naqd qarz",
    step_client: "Mijoz",
    step_type: "Turi",
    step_finance: "Moliya",
    step_docs: "Hujjatlar",
    monthly: "Oyiga {{p}} · {{n}} oy",
    seg_full: "To‘liq",
    seg_partial: "Qisman",
    seg_defer: "Kechiktirish",
    pay_amount: "To‘lov summasi",
    rest: "Qoldiq qarz: {{v}}",
  },
  faq: {
    eyebrow: "Savol-javob",
    title: "Ko‘p so‘raladigan savollar",
    subtitle: "Nasiyah haqida bilishingiz kerak bo‘lgan asosiy narsalar.",
    help_text: "Savol bo‘lsa — Telegram’da yozing.",
    help_btn: "Yozish",
    // NOTE: this array is the single source for both the FAQ UI and the
    // FAQPage JSON-LD (subtask 05). Keep the {q, a} shape stable.
    items: [
      {
        q: "Nasiya savdo nima va Nasiyah qanday yordam beradi?",
        a: "Nasiya savdo — mahsulotni bo‘lib-bo‘lib to‘lash sharti bilan sotishdir. Nasiyah qarz daftari, raqamli shartnoma va to‘lov nazoratini bitta ilovaga jamlaydi: siz kimga qancha qarz borligini, to‘lov muddatlarini va tushgan pulni real vaqtda ko‘rasiz.",
      },
      {
        q: "Nasiyah’dan foydalanishni qanday boshlayman?",
        a: "Nasiyah Biznes ilovasini App Store yoki Google Play’dan yuklab oling (iOS va Android), do‘koningizni ro‘yxatdan o‘tkazing va birinchi shartnomangizni bir necha daqiqada tuzing. Qo‘shimcha jihoz yoki murakkab o‘rnatish kerak emas.",
      },
      {
        q: "Mijozim shartnomani qanday ko‘radi va imzolaydi?",
        a: "Siz ilovada shartnoma loyihasini tuzasiz va mijozga yuborasiz. Mijoz alohida Nasiyah ilovasi (iOS/Android) orqali shartnoma shartlarini ko‘rib chiqadi va tasdiqlaydi — shundan so‘ng shartnoma kuchga kiradi. Mijoz o‘z to‘lov jadvalini va qoldiq qarzini ham shu ilovada kuzatib boradi.",
      },
      {
        q: "Pulni qachon va qanday olaman?",
        a: "Mijoz to‘lovni to‘g‘ridan-to‘g‘ri sizga to‘laydi — Nasiyah pulni ushlab qolmaydi. Ilova to‘lov jadvalini yuritadi, mijozga avtomatik eslatadi va har bir to‘lovni qayd etadi, shunda hisob-kitob doim aniq bo‘ladi.",
      },
      {
        q: "Nasiyah qancha turadi? Bepulmi?",
        a: "Qarz daftari va mijoz boshqaruvi — doimo bepul. To‘liq shartnoma, to‘lov qabuli va moliyaviy tahlil PRO-tarifda. Yangi tadbirkorlar uchun PRO dastlabki {{months}} oy bepul — keyin oyiga {{price}} so‘m.",
      },
      {
        q: "Mijoz to‘lovni kechiktirsa nima bo‘ladi?",
        a: "Tizim muddati o‘tgan to‘lovlarni belgilaydi va ham sizga, ham mijozga avtomatik eslatma yuboradi. Siz qaysi mijoz qancha qarzdor va kim kechikkanini bitta ekranda ko‘rasiz.",
      },
      {
        q: "Ma’lumotlarim xavfsizmi?",
        a: "Har bir tadbirkor faqat o‘z mijozlari ma’lumotini ko‘radi — hisoblar bir-biridan ajratilgan. Har bir shartnoma raqamli imzo bilan tasdiqlanadi, ma’lumotlar himoyalangan ulanish (HTTPS) orqali uzatiladi, va biz ma’lumotni uchinchi tomonlarga sotmaymiz.",
      },
    ],
  },
  cta: {
    eyebrow: "Bugun boshlang",
    title: "Yashirin shartlarsiz. Faqat halol tariflar.",
    subtitle:
      "Nasiyah Biznes ilovasini yuklab oling va birinchi shartnomangizni bugun tuzing. Savol bo‘lsa — Telegram’da yozing.",
    telegram_btn: "Telegram’da yozish",
  },
  footer: {
    upload: "Ilovani yuklab oling!",
    footer_copyright: "Barcha huquqlar himoyalangan.",
    product: "Mahsulot",
    contact: "Aloqa",
    address: "Toshkent, Olmazor tumani, Sag‘bon ko‘chasi, 23A",
    privacy: "Maxfiylik siyosati",
    terms: "Ommaviy oferta",
  },
  not_found: {
    meta_title: "Sahifa topilmadi — Nasiyah",
    title_pre: "Bunday sahifa ",
    title_accent: "yo‘q",
    text: "Havola eskirgan yoki manzilda xato bor. Bosh sahifaga qayting yoki bizga Telegram’da yozing.",
    home_btn: "Bosh sahifaga qaytish",
  },
};
